import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeOneComponent } from "./components/pages/home-one/home-one.component";
import { ErrorComponent } from "./components/pages/error/error.component";
import { LoginComponent } from "./components/pages/login/login.component";
import { RegisterComponent } from "./components/pages/register/register.component";
import { NewsListComponent } from "./components/pages/news-list/news-list.component";
import { HealthLibraryComponent } from "./components/pages/health-library/health-library.component";
import { WellnessInitiativesListComponent } from "./components/pages/wellness-initiatives-list/wellness-initiatives-list.component";
import { HealthPrescriptionListComponent } from "./components/pages/health-prescription-list/health-prescription-list.component";
import { SingleNewComponent } from "./components/pages/single-new/single-new.component";
import { DiseaseComponent } from "./components/pages/disease/disease.component";
import { SingleWellnessInitiativesComponent } from "./components/pages/single-wellness-initiatives/single-wellness-initiatives.component";
import { SingleHealthPrescriptionComponent } from "./components/pages/single-health-prescription/single-health-prescription.component";
import { DiscoverQuestionsListComponent } from "./components/pages/discover-questions-list/discover-questions-list.component";
import { SubscribeComponent } from "./components/pages/subscribe/subscribe.component";
import { AskDoctorComponent } from "./components/pages/ask-doctor/ask-doctor.component";
import { PatientProfileComponent } from "./components/pages/patient-profile/patient-profile.component";
import { DoctorsListComponent } from "./components/pages/doctors-list/doctors-list.component";
import { DoctorProfileComponent } from "./components/pages/doctor-profile/doctor-profile.component";
import { AskSuccessfullyComponent } from "./components/pages/ask-successfully/ask-successfully.component";
import { SavedSuccessfullyComponent } from "./components/pages/saved-successfully/saved-successfully.component";
import { SubscribedSuccessfullyComponent } from "./components/pages/subscribed-successfully/subscribed-successfully.component";
import { SomethingWrongComponent } from "./components/pages/something-wrong/something-wrong.component";
import { DiseasesListComponent } from "./components/pages/diseases-list/diseases-list.component";
import { ContactUsComponent } from "./components/pages/contact-us/contact-us.component";
import { AboutUsComponent } from "./components/pages/about-us/about-us.component";
import { PrivacyPolicyComponent } from "./components/pages/privacy-policy/privacy-policy.component";
// import { AuthGuard } from "./core/auth.guard";
import { AiDiagnosisComponent } from "./components/pages/ai-diagnosis/ai-diagnosis.component";
import { ResultsComponent } from "./components/pages/results/results.component";
import { KnowMoreComponent } from "./components/pages/know-more/know-more.component";
import { ViewCategoryComponent } from "./components/pages/health-library/view-category/view-category.component";
import { SingleArticleComponent } from "./components/pages/health-library/single-article/single-article.component";
import { SingleContentComponent } from "./components/pages/health-library/single-content/single-content.component";
import { DiagnosisHistoryComponent } from "./components/pages/patient-profile/diagnosis-history/diagnosis-history.component";
import { HomePageComponent } from "./components/pages/home-page/home-page.component";
import { HomeAiComponent } from "./components/pages/home-ai/home-ai.component";
import { AskAiComponent } from "./components/pages/ask-ai/ask-ai.component";
import { SavedContentComponent } from "./components/pages/health-library/saved-content/saved-content.component";
import { SecurityComponent } from "./components/pages/security/security.component";
import { SubscribePageComponent } from "./components/pages/subscribe-page/subscribe-page.component";
import { AskAiHistoryComponent } from "./components/pages/ask-ai-history/ask-ai-history.component";
import { OtpComponent } from "./components/pages/otp/otp.component";
import { TermsConditionsComponent } from "./components/pages/terms-conditions/terms-conditions.component";
import { AuthGuard } from "./core/auth.guard";

const routes: Routes = [
    { path: "", component: HomeOneComponent },
    {
        path:"home",component:HomePageComponent
    },
    {
        path:"ai-home",component:HomeAiComponent, canActivate: [AuthGuard]
    }, {
        path:"ask-ai",component:AskAiComponent,canActivate: [AuthGuard]
    },

    { path: "error", component: ErrorComponent },
    { path: "terms", component: TermsConditionsComponent },
    { path: "ask-history", component: AskAiHistoryComponent,canActivate: [AuthGuard] },

    { path: "subscribe", component: SubscribePageComponent },

    { path: "login", component: LoginComponent },
    { path: "ai-diagnosis", component: AiDiagnosisComponent,canActivate: [AuthGuard] },
    { path: "results", component: ResultsComponent ,canActivate: [AuthGuard]},
    { path: "know-more/:slug", component: KnowMoreComponent ,canActivate: [AuthGuard],},
    { path: "register", component: RegisterComponent},
    { path: "news-list", component: NewsListComponent , canActivate: [AuthGuard]},
    { path: "health-library", component: HealthLibraryComponent ,canActivate: [AuthGuard]},
    { path: "view-category/:id", component: ViewCategoryComponent, canActivate: [AuthGuard] },
    { path: "single-article/:id", component: SingleArticleComponent ,canActivate: [AuthGuard]},
    { path: "single-content/:id", component: SingleContentComponent ,canActivate: [AuthGuard]},
    { path: "diagnosis-history", component: DiagnosisHistoryComponent, canActivate: [AuthGuard] },
    { path: "saved-content", component: SavedContentComponent , canActivate: [AuthGuard] },
    { path: "security", component: SecurityComponent, canActivate: [AuthGuard] },

    {
        path: "wellness-initiatives",
        component: WellnessInitiativesListComponent,
    },
    { path: "health-prescription", component: HealthPrescriptionListComponent },
    { path: "single-new", component: SingleNewComponent },
    { path: "single-wellness", component: SingleWellnessInitiativesComponent },
    { path: "disease", component: DiseaseComponent },
    {
        path: "single-prescription",
        component: SingleHealthPrescriptionComponent,
    },
    { path: "discover-questions", component: DiscoverQuestionsListComponent },
    // { path: "subscribe", component: SubscribeComponent },
    { path: "ask-doctor", component: AskDoctorComponent },
    {
        path: "patient-profile",
        // canActivate: [AuthGuard],
        component: PatientProfileComponent,
    },
    { path: "doctor-list", component: DoctorsListComponent },
    { path: "ask-success", component: AskSuccessfullyComponent },
    { path: "saved-success", component: SavedSuccessfullyComponent },
    {
        path: "subscription-success",
        component: SubscribedSuccessfullyComponent,
    },
    { path: "wrong", component: SomethingWrongComponent },
    { path: "doctor-profile", component: DoctorProfileComponent },
    { path: "diseases", component: DiseasesListComponent },
    { path: "contact-us", component: ContactUsComponent,canActivate: [AuthGuard] },
    { path: "otp", component: OtpComponent, canActivate: [AuthGuard] },
    { path: "about-us", component: AboutUsComponent , canActivate: [AuthGuard] },
    { path: "privacy", component: PrivacyPolicyComponent, canActivate: [AuthGuard] },
    { path: "**", component: ErrorComponent , canActivate: [AuthGuard]},
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" }),
        RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })

    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
